module.exports = __webpack_public_path__ + "static/Q5Answer1_Green_JasonDent-c0046f8cf7c0dd1a0f93f4463b56623c.jpg";